import { useTranslation } from 'react-i18next';

import GlyphSearch from '@/assets/icons/glyph_search.svg?component';
import Select from '@/components/atoms/Select';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import TextField from '@/components/atoms/TextField';

import styles from '../CagesList.module.scss';

export interface CagesFilterProps {
    filter: string;
    onFilterChange: (value: string) => void;
    selectedClientId: string;
    onSelectedClientIdChange: (value: string) => void;
    clientOptions: Array<{ value: string; label: string }>;
    selectedLocationId: string;
    onSelectedLocationIdChange: (value: string) => void;
    locationOptions: Array<{ value: string; label: string }>;
}

export default function CagesFilter(props: CagesFilterProps) {
    const {
        filter,
        onFilterChange,
        selectedClientId,
        onSelectedClientIdChange,
        clientOptions,
        selectedLocationId,
        onSelectedLocationIdChange,
        locationOptions,
    } = props;
    const { t } = useTranslation();

    return (
        <>
            <TextField
                groupClassName={styles.searchInput}
                className={styles.searchField}
                adornmentClassName={styles.searchInputIcon}
                suffix={<SvgIcon icon={GlyphSearch} size="custom" customSize={22} />}
                value={filter}
                onChange={(event) => onFilterChange(event.target.value)}
                placeholder={t('common.labels.searchText')}
            />
            <Select
                className={styles.filterSelect}
                aria-label={t('common.labels.client')}
                value={selectedClientId}
                onChange={(event) => onSelectedClientIdChange(event.target.value)}>
                {clientOptions.map((clientOption) => (
                    <option key={clientOption.value} value={clientOption.value}>
                        {clientOption.label}
                    </option>
                ))}
            </Select>
            <Select
                className={styles.filterSelect}
                aria-label={t('common.labels.location')}
                value={selectedLocationId}
                onChange={(event) => onSelectedLocationIdChange(event.target.value)}>
                {locationOptions.map((locationOption) => (
                    <option key={locationOption.value} value={locationOption.value}>
                        {locationOption.label}
                    </option>
                ))}
            </Select>
        </>
    );
}
